import {notNull} from '../../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {SlButton, SlRadioGroup} from '@shoelace-style/shoelace/shoelace';
import {ReloadManager} from '../reloadManager';

/**
 * Funktionen fuer das DSLlist CmsModul
 *  - Filter ein und ausblenden
 */
export class Dsllist {
    private readonly viewRoot: HTMLElement;
    private readonly reloadManager: ReloadManager;
    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;
        this.reloadManager = new ReloadManager();
        this.reloadModuleDSL();
        this.registerNoScrollEventListeners();
        this.submitListeners();
    }

    private reloadModuleDSL() {
        const cmsReloadModuleDSL = this.viewRoot.querySelectorAll<HTMLAnchorElement>('.cmsReloadModuleDSL');

        cmsReloadModuleDSL.forEach((element) => {
            element.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();

                const form = notNull(element.closest('form')) as HTMLFormElement;
                if (element.classList.contains('final')) {
                    this.selectOneItem(form);
                }

                this.reloadManager.reloadModule(form, true, true);
            });
        });
    }

    // Bei TV und Speed soll immer ein Item gewaehlt werden, wenn nichts ausgeaehlt wurde
    // bei Speed -> egal -> das letzte Item
    // bei TV -> ohne tv -> das erste Item
    private selectOneItem(dslForm: HTMLFormElement): void {
        const tvList = [...dslForm.querySelectorAll<HTMLInputElement>('.tv-filter-list input')];
        const speedList = [...dslForm.querySelectorAll<HTMLInputElement>('.speed-filter-list input')];

        const tvListFirstItem = dslForm.querySelector('.tv-filter-list li:first-child input') as HTMLInputElement;
        const speedListLastItem = dslForm.querySelector('.speed-filter-list li:last-child input') as HTMLInputElement;

        if (this.isOneChecked(tvList) === false) {
            if (tvListFirstItem) {
                tvListFirstItem.checked = true;
            }
        }
        if (this.isOneChecked(speedList) === false) {
            if (speedListLastItem) {
                speedListLastItem.checked = true;
            }
        }
    }

    private isOneChecked(checkboxList: HTMLInputElement[]): boolean {
        for (let i = 0; i < checkboxList.length; i++) {
            if (checkboxList[i].checked) {
                return true;
            }
        }
        return false;
    }

    // Diese Listener greifen auch fuer das Beratungsformular der Tarifliste.
    private submitListeners() {
        // dsl form submit
        const submitForms = this.viewRoot.querySelectorAll<HTMLFormElement>('form.form-standard.consult-availability');

        submitForms.forEach((element: HTMLFormElement) => {
            element.addEventListener('submit', (event: SubmitEvent) => {
                event.preventDefault();

                this.reloadManager.reloadModule(element, true, true).finally(() => {
                    notNull(document.querySelector('body')).classList.remove('loadingdsl');
                });
            });
        });
    }

    private registerNoScrollEventListeners() {
        // es gibt Filter / Links, auf denen explizit nicht gescrollt werden soll (zb junge_Leute im dsl)
        const radios = this.viewRoot.querySelectorAll<SlRadioGroup>('sl-radio-group.cmsReloadModuleDontScroll');
        radios.forEach((radio) => {
            radio.addEventListener('sl-change', (event) => {
                const target = event.target as SlRadioGroup;
                const cmsRoot = target.closest('.cms-module-root');
                if (!cmsRoot) {
                    return;
                }
                const hiddenField = cmsRoot.querySelector<HTMLInputElement>('#hidden_' + target.name);
                if (!hiddenField) {
                    return;
                }
                hiddenField.value = target.value;

                this.reloadManager.cmsReloadModule(event, true, false);
            });
        });
    }
}
